<template>
  <div>
    <form novalidate @submit.prevent="save">
      <base-input
        type="text"
        name="firstName"
        :required="true"
        v-model="firstNameValue"
        :validation-rules="firstNameValidationSchema"
      >
        <template #label>
          <translate>First name</translate>
        </template>
        <template #errorMessage>
          <translate>Please tell us your first name</translate>
        </template>
      </base-input>
      <base-input
        type="text"
        name="lastName"
        :required="true"
        v-model="lastNameValue"
        :validation-rules="lastNameValidationSchema"
      >
        <template #label>
          <translate>Last name</translate>
        </template>
        <template #errorMessage>
          <translate>Please tell us your last name</translate>
        </template>
      </base-input>
      <div class="action-buttons">
        <a class="button minimal cancel" @click.prevent="$emit('close')">
          <translate>Cancel</translate>
        </a>
        <base-submit-button class="primary asblock">
          <translate>Save</translate>
        </base-submit-button>
      </div>
    </form>
  </div>
</template>

<script lang="ts" setup>
import { Pinia } from 'pinia'
import { useForm } from 'vee-validate'
import { z } from 'zod'

const userDataStore = useUserDataStore(usePinia() as Pinia)

const { validate, setErrors } = useForm()

const firstNameValue = ref(userDataStore.userDetails?.firstName || '')
const lastNameValue = ref(userDataStore.userDetails?.lastName || '')

const firstNameValidationSchema = z
  .string({ required_error: 'required' })
  .nonempty({ message: 'required' })

const lastNameValidationSchema = z
  .string({ required_error: 'required' })
  .nonempty({ message: 'required' })

const emit = defineEmits<{
  (e: 'close'): void
}>()

async function save() {
  const isValid = (await validate()).valid
  if (!isValid) return
  try {
    await userDataStore.saveUserData(firstNameValue.value, lastNameValue.value)
    emit('close')
  } catch (error: any) {
    const errorData = error as {
      errors: { first_name: string; last_name: string }
    }
    setErrors({
      firstName: errorData.errors.first_name,
      lastName: errorData.errors.last_name,
    })
  }
}
</script>

<style scoped>
form > div:nth-child(2) {
  margin-top: 1em;
}

.action-buttons {
  display: flex;
  align-items: right;
  justify-content: flex-end;
  margin: 2em 0 0;
  padding-bottom: 1em;
  gap: 2em;
}

.cancel {
  margin-top: 0.25em;
}
</style>
